import React from 'react';
import PrintableHonorCard from './printable-honor-card';


export default class PrintableList extends React.Component {
	constructor(props) {
		super(props);
		
	}

	render() {
		const honor_card_pdfs = this.props.honor_card_pdfs;

		return (
			<div>
				<h3>Download a Printable Card</h3>
				<div className="honor-card-pdfs">
					
					{honor_card_pdfs.map((honor_card_pdf, index) => (

					<PrintableHonorCard key={index} name={honor_card_pdf.name} image={honor_card_pdf.image} pdf={honor_card_pdf.pdf} />
					))}
				</div>
				<h3>or</h3>
			</div>
		);
	}
}